export default "__VITE_ASSET__x81I2sNR__"